import { useLoaderData } from '@remix-run/react';
import { getBrowserInfo } from '~/utils/browser';
interface ReportBugButtonProps {
  title?: string;
  body?: string;
  labels?: string[];
  className?: string;
}
interface LoaderData {
  NEXT_PUBLIC_GITHUB_REPO: string;
}

export const ReportBugButton = ({ title, body, labels = ['bug'], className }: ReportBugButtonProps) => {
  const { NEXT_PUBLIC_GITHUB_REPO } = useLoaderData<LoaderData>();

  const createGithubIssueUrl = () => {
    const baseUrl = `https://github.com/${NEXT_PUBLIC_GITHUB_REPO}/issues/new`;
    const browserInfo = getBrowserInfo();
    const enhancedBody = `${body}\n\n## System Information\n\`\`\`json\n${JSON.stringify({ browserInfo }, null, 2)}\n\`\`\`\n`;
    console.log('labels', browserInfo);

    const params = new URLSearchParams();
    params.append('title', title);
    params.append('body', enhancedBody);
    params.append('labels', labels.join(','));
    console.log('params', params.toString());

    return `${baseUrl}?${params.toString()}`;
  };

  return (
    <a
      href={createGithubIssueUrl()}
      target="_blank"
      rel="noopener noreferrer"
      className={`rounded-lg text-gray-300 text-sm font-medium transition-colors ${className}`}
    >
      {title}
    </a>
  );
};
